<template>
    <div
        id="app"
        class="my-app"
    >
        <router-view />
    </div>
</template>

<script>
export default {
    created() {
        if(location.href.indexOf('meeting/authorize/callback') !== -1){
            const match_auth_code = location.href.match(/auth_code=(.*?)&/);
            const match_state_code = location.href.match(/state=(.*?)#/);
            const auth_code = (match_auth_code && match_auth_code.length > 1) ? match_auth_code[1] : '';
            const state_code = (match_state_code && match_state_code.length > 1) ? match_state_code[1] : '';
            const hash = location.hash;
            
            if (auth_code && state_code) {
                const currentHash = hash.replace(/[`~!#$\\|{};:"',<>]+/, '');
                const auth_code_new = auth_code.replace(/[`~!#$\\|{};:"',<>]+/, '');
                const state_code_new = state_code.replace(/[`~!#$\\|{};:"',<>]+/, '');
                location.replace(process.env.BASE_URL+'#'+currentHash+"&auth_code="+auth_code_new+"&state="+state_code_new);
            }        
        }
    }
}
</script>
<style lang="less">
@import '~@/assets/sprite/public';
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
xmp,
code,
form,
fieldset,
legend,
input,
select,
textarea,
p,
blockquote,
th,
td {
    margin: 0;
    padding: 0;
}
html {
    height: 100%;
}
body {
    height: 100%;
    font: 12px/1.231 'Helvetica Neue', Helvetica Neue, Helvetica, Arial,
        Lantinghei SC, Hiragino Sans GB, Microsoft Yahei, sans-serif;
}
pre,textarea{
    font: 12px/1.231 'Helvetica Neue', Helvetica Neue, Helvetica, Arial,
        Lantinghei SC, Hiragino Sans GB, Microsoft Yahei, sans-serif;
}
a {
    cursor: pointer;
}
.my-app {
    font-size: 12px;
    height: 100%;
}
.clearfix {
    zoom: 1;
    &:after {
        content: '.';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
        font-size: 0;
    }
}
li {
    list-style: none;
}
#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
.tips-ctl {
    display: inline-block;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    background: #fff9b7;
    padding: 5px 40px;
    border: 1px solid #e6e2b2;
    border-radius: 2px;
    box-shadow: 0 0 1px #e6e2b2;
    min-width: 180px !important;
}
.el-message__icon {
    display: none !important;
}
.el-message__closeBtn {
    display: none !important;
}
.el-message--success .el-message__content {
    color: #777441 !important;
}
.el-message.is-closable .el-message__content {
    padding-right: 0;
}
body,
.el-table__body-wrapper,
.webkit-scrollbar {
    &::-webkit-scrollbar {
        width: 9px;
        height: 9px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0);
    }

    &::-webkit-scrollbar-track:hover {
        background-color: rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: -2px 0 0 #fff inset,
            1px 0 0 rgba(255, 255, 255, 0.9) inset,
            0 -1px 0 rgba(255, 255, 255, 0.9) inset,
            0 1px 0 rgba(255, 255, 255, 0.9) inset;
    }

    &::-webkit-scrollbar-track:active {
        background-color: rgba(0, 0, 0, 0.1);
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background-color: rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: -2px 0 0 #fff inset, 1px 0 0 #fff inset,
            0 -1px 0 rgba(255, 255, 255, 0.9) inset,
            0 1px 0 rgba(255, 255, 255, 0.9) inset;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.4);
    }

    &::-webkit-scrollbar-thumb:active {
        background: rgba(0, 0, 0, 0.6);
    }
}
.bulid-result {
        width: 40px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        display: inline-block;
        font-size: 12px;
        margin-left: 3px;
        &.success {
            background-color: #93c36b;
            color: #fff;
        }
        &.failure {
            background-color: #f85e5e;
            color: #fff;
        }
        &.no-build {
            color: #404a56;
            font-size: 14px;
        }
        &.building {
            color: #404a56;
        }
    }

    //覆盖eui弹窗样式，保持与主站一致
    .el-dialog{
        .el-dialog__header{
            padding: 10px 15px 10px;
            border-bottom: solid;
            border-width: thin;
            border-color:#F0F0F0;
            .el-dialog__title{
                font-size:12px;
                line-height: 18px;
            }
            .el-dialog__headerbtn{
                top:10px;
                right:15px;
            }

        }
    }

</style>
